<template>
    <div class="radikalische-substitution-mechanismus">
        <img
            src="@/assets/img/reaktionen/radikalische-substitution/ablauf.gif"
            alt="Radikalische Substitution"
            title="Radikalische Substitution"
            width="100%"
        />
        <small
            ><a
                href="http://www.chemgapedia.de/vsengine/vlu/vsc/de/ch/12/oc/vlu_organik/radikale/substitutionsmech.vlu/Page/vsc/de/ch/12/oc/radikale/subst_mechanismus/subst_mechanismus.vscml.html"
                target="_blank"
                >Quelle</a
            ></small
        >
    </div>
</template>

<script>
export default {
    name: 'radikalische-substitution-mechanismus',
};
</script>
